export default {
  read: {
    title: "Servicios",
    subtitle:
      "Rellena todos los datos de tus servicios y muestra tu trabajo en tu web.",
    createNewBtn: "Nuevo Servicio",
    search: "Buscar Servicios",
    see: "Ver servicios",
    details: "Ver calendario",
    modal: {
      header: {
        title: "Diseño",
        section: "Servicios"
      },
      sections: {
        title: {
          separator: "Título",
          titleLabel: "Título",
          subtitleLabel: "Subtítulo"
        },
        background: {
          separator: "Fondo",
          colorLabel: "Color fondo",
          cardsColorLabel: "Color fondo tarjetas"
        }
      },
      save: "Guardar"
    }
  },
  create: {
    title: "Nuevo servicio",
    subtitle:
      "Rellena todos los datos de tus servicios y muestra tu trabajo en tu web.",
    form: {
      title: "Servicios que ofreces",
      subtitle: "Define los servicios que marcan a tu empresa.",
      image: "Icono",
      name: "Nombre del servicio",
      description: {
        title: "Descripción",
        subtitle:
          "La decripción se incluirá justo debajo del título que cada servicio. Máx 200 carácteres"
      }
    },
    price: {
      title: "Pago por adelantado",
      label: "Precio"
    },
    bookings: {
      title: "Reservas online",
      label: "Link a Calendy / Google Calendar"
    },
    notifications: {
      created: "Servicio creado con éxito",
      edited: "Servicio actualizado con éxito",
      removed: "Servicio eliminado con éxito"
    },
    highlight: {
      label: "Destacar evento",
      under: "Servicio destacado"
    },
    actions: {
      add: "Añadir servicio",
      save: "Guardar servicios",
      delete: "Eliminar servicio",
      cancel: "Cancelar"
    }
  }
};
